import React,{ Component, Fragment } from "react";
import InputText from "../common/Form";

import Button from '@mui/material/Button';

import TextField from '@mui/material/TextField';
import { Box, IconButton } from "@mui/material";
import TabsContent from "../common/TabsContent";
import { Visibility, VisibilityOff } from "@mui/icons-material";

class Register extends Component{
    state = {
        employee_lastname: "", 
        employee_matricule: "",
        password: "",
        password2: "",
        errors:{
            employee_lastname: "", 
            employee_matricule: "",
            password: "",
            password2: "",
        },
        showPassword: false,
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleChange = (e) => {
        const { name, value } = e.target;
       
        this.setState({
            [name]: value
        })
    }
    validPassword = (password) => {
        let isValid = true
        let re = /[0-9]/;
        if(!re.test(password)) {
            isValid = false
        }
        re = /[a-z]/;
        if(!re.test(password)) {
            isValid = false
        }
        re = /[A-z]/;
        if(!re.test(password)) {
            isValid = false
        }
        if(password.length < 6){
            isValid = false
        }
        
        return isValid;
    }

    validate = (form) => {
        console.log('[Info] validate, entrer function,',{form});
        let noError = true
        let errors = {}
        let required = [
            "employee_lastname", 
            "employee_matricule",
            // "password",
        ]  
        if (form === "register") {
            
            let isValid = this.validPassword(this.state.password);
            if (!isValid){
                noError = false
                errors.password = "Le mot de passe doit contenir au minimum 6 caractères dont un chiffre, une majuscule et une minuscule"
            }

            if( this.state.password2 !== this.state.password ) {
                console.log('[ERROR] validate, password are not identique :');
                errors.password2 = "Le mot de passe et sa confirmation doivent être identiques" 
                noError = false
            } else {
                errors.password2 = "" 
            }
        }
           
        required.map(field => {
            if(!this.state[field]){
                noError = false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
        console.log('[Info] validate ',{errors, noError} );
        this.setState({
            errors
        })
        return noError
    }
    
    // L'API peut répondre soit un message texte, soit un objet ({ error_code, message }).
    // On en extrait toujours une chaîne affichable + le code éventuel, pour ne jamais
    // afficher "[object Object]" à l'utilisateur.
    getErrorInfo = (res) => {
        const data = (res && res.data) || {};
        const rawError = data.error;
        let message = "";

        if (typeof rawError === "string"){
            message = rawError
        } else if (rawError && typeof rawError.message === "string"){
            message = rawError.message
        }

        return { code: data.error_code, message }
    }

    handleSubmit = async (type) => {
        if(this.validate(type)){
            let data = {
                employee_lastname: this.state.employee_lastname.trim(), 
                employee_matricule: this.state.employee_matricule.trim(),
                employee_password: this.state.password
            }
            if (type === "register"){
                const res = await this.props.registerEmployee(data)
                if (res === "ok"){
                    return
                }

                const { code, message } = this.getErrorInfo(res);
                console.log('[ERROR],Register,handleSubmit,  err', code || message);

                let msg = message
                    ? "Un Problème est survenu  : " + message
                    : "Un Problème est survenu, veuillez réessayer plus tard";
                if (message === "user and password don't match"){
                    msg = "Un Problème est survenu  : Le mot de passe et l'email ne correspondent pas"
                }

                this.props.notif(true,"error",msg)
                return;
            } else {
                const res = await this.props.logEmployee(data)
                if (res === "ok"){
                    return
                }

                const { code, message } = this.getErrorInfo(res);
                console.log('[ERROR],Register,handleSubmit,  err', code || message);

                let msg = message
                    ? "Un Problème est survenu  : " + message
                    : "Un Problème est survenu, veuillez réessayer plus tard";
                if (code === "WAITING_ACTIVATION"){
                    msg = "Votre compte n'a pas encore été confirmé. Consultez votre boîte de réception (et vos spams) pour l'activer."
                } else if (message === "user and password don't match"){
                    msg = "Un Problème est survenu  : Le mot de passe et l'identifiant ne correspondent pas"
                }

                this.props.notif(true,"error",msg)
                return;
            }
            
        } else {
            this.props.notif(true,"error","Le Formulaire contient des erreurs")
        }
    }

    render(){
        console.log('[INFO], Register, State,',this.state);
        console.log(this.props);
        const {showPassword} = this.state;
        return(
            <Box>
                <TabsContent
                    labels={["Connexion", "Inscription"]}
                >
                    <Box> 
                        <InputText
                            required 
                            onChange={this.handleChange} 
                            name="employee_lastname" 
                            value={this.state.employee_lastname} 
                            label="Nom" 
                            error={this.state.errors.employee_lastname} 
                        />
                        <InputText
                            required 
                            onChange={this.handleChange} 
                            name="employee_matricule" 
                            value={this.state.employee_matricule} 
                            label="Matricule" 
                            error={this.state.errors.employee_matricule} 
                        />
                        <InputText
                            required 
                            onChange={this.handleChange} 
                            name="password" 
                            value={this.state.password} 
                            label="Mot de Passe" 
                            type="password" 
                            error={this.state.errors.password} 
                            type={showPassword ? 'text' : 'password'}
                            endAction={
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => this.setState({showPassword: !showPassword})}
                                    // onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                                
                            }
                        />
                
                        <Box p={2} style={{textAlign: "center"}} >
                            <Button color="secondary" variant="contained" size="large" 
                                onClick={ () => this.handleSubmit("login") } 
                            >
                                Valider
                            </Button>
                        </Box>
                    </Box>
                    
                    <Box> 
                        <InputText
                            required 
                            onChange={this.handleChange} 
                            name="employee_lastname" 
                            value={this.state.employee_lastname} 
                            label="Nom" 
                            error={this.state.errors.employee_lastname} 
                        />
                        <InputText
                            required 
                            onChange={this.handleChange} 
                            name="employee_matricule" 
                            value={this.state.employee_matricule} 
                            label="Matricule" 
                            error={this.state.errors.employee_matricule} 
                        />
                        <InputText
                            required 
                            onChange={this.handleChange} 
                            name="password" 
                            value={this.state.password} 
                            label="Mot de Passe" 
                            type="password" 
                            error={this.state.errors.password} 
                        />
                        <InputText
                            required 
                            onChange={this.handleChange} 
                            name="password2" 
                            value={this.state.password2} 
                            label="Confirmer le Mot de Passe" 
                            type="password" 
                            error={this.state.errors.password2} 
                        />
                
                        <Box p={2} style={{textAlign: "center"}} >
                            <Button color="secondary" variant="contained" size="large" 
                                onClick={ () => this.handleSubmit("register") } 
                            >
                                Valider
                            </Button>
                        </Box>
                    
                    </Box>
                </TabsContent>
                
            </Box>
        )
    }
}

export default Register;